import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  let typeNumbers = document.querySelectorAll('.type-number');
  let speed = 150;
  let typeNumberIntervals = Object.create({});

  typeNumbers.forEach((typeNumber, index) => {
    let chars = typeNumber.textContent;
    let counter = 1;

    typeNumber.innerHTML = '&nbsp;';

    ScrollTrigger.create({
      trigger: typeNumber,
      start: 'center 75%',
      onEnter: () => {
        if(typeNumber.dataset.played !== 'true') {
          typeNumberIntervals[index] = window.setInterval(() => {
            typeNumber.textContent = chars.substring(0, counter);
            counter++;
            if (counter > chars.length) {
              window.clearInterval(typeNumberIntervals[index]);
            }
          }, speed)
          typeNumber.dataset.played = 'true';
        }
      }
    })
  })
})
